import { ChartConfig } from "../helpers/constant";
import SuperProjection from "../models/superProjection";
import { mapActions } from "vuex";
import { SET_LOADER_VISIBILITY } from "../helpers/vuex-constants";

export default {
  data() {
    return {
      linePlotData: [],
      superSelectedComponent: "chart-area",
      projectionData: {},
      superselectedTabComponent: "superbalance",
      superChartTabContent: this.getSuperChartTab(),
      superChartTabContentTable: this.getSuperChartTabTable(),
      superRightToolSummary: [
        { key: "Current Balance", value: "$0" },
        { key: "Balance AT Retirement", value: "$0" },
        { key: "Balance Run Out At", value: "-" },
      ],
    };
  },
  computed: {
    superChartTabContentData() {
      if (this.showTableView) {
        return this.superChartTabContentTable;
      } else return this.superChartTabContent;
    },
  },

  methods: {
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    RemapSuperGraphsModel(timeseriesData, isShowRisk) {
      this.superRightToolSummary = [
        {
          key: "Current Balance",
          value: this.projectionModel.currentBalance,
        },
        {
          key: "Balance at Retirement",
          value: this.projectionModel.RetirementBalance,
        },
        {
          key: "Balance runs out at age",
          value: this.projectionModel.BalanceRunOutAt,
        },
      ];
      this.chartData = {
        superContribution:
          this.projectionModel.superContributionWithdrawalGraphData,
        superbalance: this.projectionModel.superBalanceGraphData,
        incomeExpense: this.projectionModel.incomeExpenseGraphData,
        superReturnFees: this.projectionModel.superReturnFeesGraphData,
        superTimeSeries: timeseriesData
          ? this.getTimeSeriesData(timeseriesData, isShowRisk)
          : [],
      };
      let key = this.getgraphKey();
      this.onChangeChartTab(
        this.superselectedTabComponent,
        ChartConfig[key].yAxisLabel,
        ChartConfig[key].component,
        ChartConfig[key].legendItems,
        ChartConfig[key].legendColors,
        ChartConfig[key]
      );
    },

    getTimeSeriesData(timeseriesData, isShowRisk) {
      let typeData = this.getTimeSeriesCoordinate(
        timeseriesData,
        isShowRisk,
        this.projectionYear,
        this.ProjectionDate
      );
      return { data: typeData };
    },
    getgraphKey() {
      if (this.superselectedTabComponent == "superbalance") {
        return "BalanceGraph";
      } else if (this.superselectedTabComponent == "incomeExpense") {
        return "IncomeExpenseGraph";
      } else if (this.superselectedTabComponent == "superContribution") {
        return "ContributionGraph";
      } else if (this.superselectedTabComponent == "superReturnFees") {
        return "ReturnFeesGraph";
      } else {
        return "TimeSeriesFeesGraph";
      }
    },
    onChangeSuperChartTab(tabId) {
      this.chartGraphData = [];
      let selectedTab = this.superChartTabContent.filter(
        (sr) => sr.id == tabId
      );
      if (selectedTab.length > 0) {
        this.superselectedTabComponent = tabId;
        this.superSelectedComponent = selectedTab[0].component;

        this.onChangeChartTab(
          this.superselectedTabComponent,
          selectedTab[0].yAxisLabel,
          selectedTab[0].component,
          selectedTab[0].legendItems,
          selectedTab[0].legendColors,
          selectedTab[0]
        );
        if (tabId == "incomeExpense") {
          this.superSelectedComponent = "chart-bar";
        }
      }
    },
    getSuperChartTabTable() {
      let chartTabContent = [];

      chartTabContent.push({
        text: "Details",
        active: true,
      });

      return chartTabContent;
    },
    getSuperChartTab() {
      let chartTabContent = [];

      chartTabContent.push({
        text: ChartConfig["BalanceGraph"].text,
        id: "superbalance",
        active: true,
        component: ChartConfig["BalanceGraph"].component,
        legendItems: ChartConfig["BalanceGraph"].legendItems,
        yAxisLabel: ChartConfig["BalanceGraph"].yAxisLabel,
      });
      chartTabContent.push({
        text: ChartConfig["IncomeExpenseGraph"].text,
        id: "incomeExpense",
        active: false,
        component: ChartConfig["IncomeExpenseGraph"].component,
        legendItems: ChartConfig["IncomeExpenseGraph"].legendItems,
        yAxisLabel: ChartConfig["IncomeExpenseGraph"].yAxisLabel,
        legendColors: ChartConfig["IncomeExpenseGraph"].legendColors,
        lineColor: ChartConfig["IncomeExpenseGraph"].lineColor,
      });
      chartTabContent.push({
        text: ChartConfig["ContributionGraph"].text,
        id: "superContribution",
        active: false,
        component: ChartConfig["ContributionGraph"].component,
        legendItems: ChartConfig["ContributionGraph"].legendItems,
        legendColors: ChartConfig["ContributionGraph"].legendColors,
        yAxisLabel: ChartConfig["ContributionGraph"].yAxisLabel,
      });
      chartTabContent.push({
        text: ChartConfig["ReturnFeesGraph"].text,
        id: "superReturnFees",
        active: false,
        component: ChartConfig["ReturnFeesGraph"].component,
        legendItems: ChartConfig["ReturnFeesGraph"].legendItems,
        legendColors: ChartConfig["ReturnFeesGraph"].legendColors,
        yAxisLabel: ChartConfig["ReturnFeesGraph"].yAxisLabel,
      });

      return chartTabContent;
    },
    getSuperTimeSeriesChartTab() {
      let chartTabContent = this.getSuperChartTab();

      chartTabContent = chartTabContent.concat({
        text: ChartConfig["TimeSeriesFeesGraph"].text,
        id: "superTimeSeries",
        active: false,
        component: ChartConfig["TimeSeriesFeesGraph"].component,
        legendItems: ChartConfig["TimeSeriesFeesGraph"].legendItems,
        legendColors: ChartConfig["TimeSeriesFeesGraph"].legendColors,
        yAxisLabel: ChartConfig["TimeSeriesFeesGraph"].yAxisLabel,
      });
      this.superChartTabContent = chartTabContent;
      return chartTabContent;
    },

    async getProjectionDataFromIce(s3FilePath, userInput) {
      this.chartData = {};

      let apiModel = this.prepareAPIModel(userInput);
      this.setLoaderVisibility(true);
      let apiResponse = await this.getProjection(apiModel, s3FilePath);
      this.setLoaderVisibility(false);
      return apiResponse;
    },

    getSuperChartModel(
      clientDetail,
      iceAPiResponse,
      isShowEmptyState,
      userInput
    ) {
      let apiResponse = iceAPiResponse;
      if (!isShowEmptyState) {
        userInput[0].referenceGuid =
          apiResponse.superAccumulationResult[0].referenceGuid;
      }
      this.projectionData = SuperProjection.setSuperProjections(
        apiResponse,
        userInput,
        clientDetail.entityType,
        clientDetail.clientId
      );
      if (this.projectionData.length == 0) {
        return;
      }
      return this.setSuperModel(this.projectionData, this.userInput);
    },
  },
};
